import {z} from 'zod';
import {Date} from './date';

export const CalculateTransferFeeResult = z.object({
  contractNumber: z.string(),
  terminationDate: Date,
  transferFee: z.number(),
  prepaymentPenalty: z.number(),
  interestRefund: z.number(),
});

export type CalculateTransferFeeResult = z.infer<typeof CalculateTransferFeeResult>;
